import React from 'react';
import FocusLock from 'react-focus-lock';
import ReactDOM from 'react-dom';
import { hack } from '../browser/launch';

const TAB_KEY = 9;

export default class FocusLockFocusGuard extends React.Component<any, any> {
    // queryString:string='button:not([disabled]):not([style="opacity:0;"]), [href], input:not([type="reset"]), select, textarea, [tabindex]:not([tabindex="-1"]), video';
    queryString: string='button:not([disabled]):not([disabled="true"]):not([tabindex="-1"]), [href], input:not([type="reset"]), select, textarea, [tabindex]:not([tabindex="-1"]), video';
    focusableItems: any;
    firstfocusableitem: any;
    lastfocusableitem: any;
    observer: any;
    disabled = this.props.disabled;
    functiondisabled = this.props.functiondisabled;
    className = this.props.className;
    config = { attributes: true, childList: true, subtree: true };
    ref= React.createRef<HTMLDivElement>();

    tablastItem(event: any, tabToItem: any, tabItems: any ) {
        if (event.keyCode === TAB_KEY && !event.shiftKey && event.target===tabItems[tabItems.length-1]) {            
            event.preventDefault();
            tabToItem.focus();
        }
    }

    shifttabfirstItem(event: any, tabToItem: any, tabItems: any ) {
        if (event.keyCode === TAB_KEY && event.shiftKey && event.target===tabItems[0]) {
            event.preventDefault();
            tabToItem.focus();
        }
    }

    componentDidMount() {
        var node = ReactDOM.findDOMNode(this); 
        if (node) {
            this.focusableItems = (node as Element).querySelectorAll(this.queryString);
            this.firstfocusableitem=this.focusableItems[0];
            this.lastfocusableitem=this.focusableItems[this.focusableItems.length-1];

            this.lastfocusableitem.addEventListener('keydown', 
                        (event: any) => {this.tablastItem(event, this.firstfocusableitem, this.focusableItems); }, true); 
            this.firstfocusableitem.addEventListener('keydown', 
                        (event: any) => {this.shifttabfirstItem(event, this.lastfocusableitem, this.focusableItems); }, true);               

            // developer.mozilla.org/en-US/docs/Web/API/MutationObserver
            this.observer = 
                new MutationObserver(() => {              
                    var currentFocussableItems = (node as Element).querySelectorAll(this.queryString);
                    if (this.focusableItems&&currentFocussableItems) {
                        if (this.focusableItems.length!==currentFocussableItems.length) {
                            // begin test
                            if (this.lastfocusableitem && this.firstfocusableitem) {
                                this.lastfocusableitem.removeEventListener('keydown', 
                                (event: any) => {this.tablastItem(event, this.firstfocusableitem, this.focusableItems); }, true); 
                                this.firstfocusableitem.removeEventListener('keydown', 
                                (event: any) => {this.shifttabfirstItem(event, this.lastfocusableitem, this.focusableItems); }, true);              
                            }
                            // end test
                            this.focusableItems=currentFocussableItems;
                            // begin test
                            this.firstfocusableitem=this.focusableItems[0];
                            this.lastfocusableitem=this.focusableItems[this.focusableItems.length-1];
                            this.lastfocusableitem.addEventListener('keydown', 
                                (event: any) => {this.tablastItem(event, this.firstfocusableitem, this.focusableItems); }, true); 
                            this.firstfocusableitem.addEventListener('keydown', 
                                (event: any) => {this.shifttabfirstItem(event, this.lastfocusableitem, this.focusableItems); }, true);
                            // end test
                        }
                    }
                })
            .observe(this.ref.current, this.config);
            }

    }

    public componentDidUpdate() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.lastfocusableitem && this.firstfocusableitem) {
            this.lastfocusableitem.removeEventListener('keydown', 
            (event: any) => {this.tablastItem(event, this.firstfocusableitem, this.focusableItems); }, true); 
            this.firstfocusableitem.removeEventListener('keydown', 
            (event: any) => {this.shifttabfirstItem(event, this.lastfocusableitem, this.focusableItems); }, true);              
        }
        if (this.lastfocusableitem && this.firstfocusableitem) {
            
            var node = ReactDOM.findDOMNode(this); 
            this.focusableItems = (node as Element).querySelectorAll(this.queryString);
            this.firstfocusableitem=this.focusableItems[0];
            this.lastfocusableitem=this.focusableItems[this.focusableItems.length-1];
            this.lastfocusableitem.addEventListener('keydown', 
                (event: any) => {this.tablastItem(event, this.firstfocusableitem, this.focusableItems); }, true); 
            this.firstfocusableitem.addEventListener('keydown', 
                (event: any) => {this.shifttabfirstItem(event, this.lastfocusableitem, this.focusableItems); }, true);   
        }
    }
    
    public componentWillReceiveProps(nextProps: any) {
        if(this.props.disabled !== nextProps.disabled && nextProps.disabled) { 
            if (this.props.functiondisabled) {
                // (this.props as any).custom(this.props.functiondisabled());
                hack.store.dispatch(this.props.functiondisabled);
            }
        }
        if(this.props.disabled !== nextProps.disabled && !nextProps.disabled) { 
            if (this.firstfocusableitem) {
                // tslint:disable-next-line
                setTimeout(() => { this.firstfocusableitem.focus(); }, 500);
            }
        }        
   } 

    public componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.lastfocusableitem && this.firstfocusableitem) {
            this.lastfocusableitem.removeEventListener('keydown', 
                (event: any) => {this.tablastItem(event, this.focusableItems,this.focusableItems); }, true);
            this.firstfocusableitem.removeEventListener('keydown', 
                (event: any) => {this.shifttabfirstItem(event, this.focusableItems,this.focusableItems); }, true);
        }
    }

    public render() { 
        return (
            <FocusLock className={this.className} noFocusGuards={true} disabled={this.disabled}>
                <div className={this.className} ref={this.ref}>{this.props.children as JSX.Element}</div>
            </FocusLock>
        );
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/focuslock/focuslockext.tsx